module.exports = __webpack_public_path__ + "static/media/401.788ea45e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/401.svg
// module id = 541
// module chunks = 0